const CREATE_THIRD_PARTY_REQUESTS = 'CREATE_THIRD_PARTY_REQUESTS';
const MODIFY_OWNED_THIRD_PARTY_REQUESTS = 'MODIFY_OWNED_THIRD_PARTY_REQUESTS';
const MODIFY_ALL_THIRD_PARTY_REQUESTS = 'MODIFY_ALL_THIRD_PARTY_REQUESTS';
const MODIFY_ALL_IN_FLIGHT_THIRD_PARTY_REQUESTS =
  'MODIFY_ALL_IN_FLIGHT_THIRD_PARTY_REQUESTS';
const MODIFY_ALL_REQUESTS_STATUSES = 'MODIFY_ALL_REQUESTS_STATUSES';
const VIEW_THIRD_PARTY_REQUESTS = 'VIEW_THIRD_PARTY_REQUESTS';
const VIEW_OWNED_THIRD_PARTY_REQUESTS = 'VIEW_OWNED_THIRD_PARTY_REQUESTS';
const VIEW_ALL_THIRD_PARTY_REQUESTS = 'VIEW_ALL_THIRD_PARTY_REQUESTS';
const VIEW_DEPT_THIRD_PARTY_REQUESTS = 'VIEW_DEPT_THIRD_PARTY_REQUESTS';
const RENEW_ALL_THIRD_PARTY_REQUESTS = 'RENEW_ALL_THIRD_PARTY_REQUESTS';
const RENEW_OWNED_THIRD_PARTY_REQUESTS = 'RENEW_OWNED_THIRD_PARTY_REQUESTS';
const EXPORT_REQUESTS = 'EXPORT_REQUESTS';
const CREATE_PRESCREENING_QUESTIONS = 'CREATE_PRESCREENING_QUESTIONS';
const MODIFY_PRESCREENING_QUESTIONS = 'MODIFY_PRESCREENING_QUESTIONS';
const CREATE_QUESTIONNAIRE_QUESTIONS = 'CREATE_QUESTIONNAIRE_QUESTIONS';
const MODIFY_QUESTIONNAIRE_QUESTIONS = 'MODIFY_QUESTIONNAIRE_QUESTIONS';
const ADMIN_TOOLS = 'ADMIN_TOOLS';
const VIEW_ALL_USERS = 'VIEW_ALL_USERS';
const VIEW_THIRD_PARTY_USER = 'VIEW_THIRD_PARTY_USER';
const VIEW_THIRD_PARTY_USER_FOR_THIRD_PARTY =
  'VIEW_THIRD_PARTY_USER_FOR_THIRD_PARTY';
const CREATE_ALL_USERS = 'CREATE_ALL_USERS';
const CREATE_THIRD_PARTY_USER = 'CREATE_THIRD_PARTY_USER';
const MODIFY_USERS = 'MODIFY_USERS';
const VIEW_THIRD_PARTY = 'VIEW_THIRD_PARTY';
const CREATE_THIRD_PARTY = 'CREATE_THIRD_PARTY';
const CREATE_THIRD_PARTY_USER_FOR_THIRD_PARTY =
  'CREATE_THIRD_PARTY_USER_FOR_THIRD_PARTY';
const MODIFY_THIRD_PARTY = 'MODIFY_THIRD_PARTY';
const MODIFY_QUESTIONNAIRE = 'MODIFY_QUESTIONNAIRE';
const MODIFY_ANY_QUESTIONNAIRE = 'MODIFY_ANY_QUESTIONNAIRE';
const AUDIT_LOG = 'AUDIT_LOG';
const VIEW_QUESTIONNAIRE_ATTACHMENTS = 'VIEW_QUESTIONNAIRE_ATTACHMENTS';
const CREATE_DISPLAY_CATEGORIES = 'CREATE_DISPLAY_CATEGORIES';
const MODIFY_DISPLAY_CATEGORIES = 'MODIFY_DISPLAY_CATEGORIES';
const VIEW_DISPLAY_CATEGORIES = 'VIEW_DISPLAY_CATEGORIES';
const CREATE_QUESTION_TYPES = 'CREATE_QUESTION_TYPES';
const MODIFY_QUESTION_TYPES = 'MODIFY_QUESTION_TYPES';
const VIEW_QUESTION_TYPES = 'VIEW_QUESTION_TYPES';
const CREATE_DEPARTMENTS = 'CREATE_DEPARTMENTS';
const MODIFY_DEPARTMENTS = 'MODIFY_DEPARTMENTS';
const VIEW_DEPARTMENTS = 'VIEW_DEPARTMENTS';
const VIEW_REQUEST_ATTACHMENT = 'VIEW_REQUEST_ATTACHMENT';
const VIEW_ALL_REQUEST_ATTACHMENT = 'VIEW_ALL_REQUEST_ATTACHMENT';
const UPLOAD_REQUEST_ATTACHMENT = 'UPLOAD_REQUEST_ATTACHMENT';
const UPLOAD_ALL_REQUEST_ATTACHMENT = 'UPLOAD_ALL_REQUEST_ATTACHMENT';
const DELETE_REQUEST_ATTACHMENT = 'DELETE_REQUEST_ATTACHMENT';
const DELETE_ALL_REQUEST_ATTACHMENT = 'DELETE_ALL_REQUEST_ATTACHMENT';
const VIEW_QUESTIONNAIRE_ATTACHMENT = 'VIEW_QUESTIONNAIRE_ATTACHMENT';
const VIEW_ALL_QUESTIONNAIRE_ATTACHMENT = 'VIEW_ALL_QUESTIONNAIRE_ATTACHMENT';
const VIEW_OWNED_QUESTIONNAIRE_ATTACHMENT =
  'VIEW_OWNED_QUESTIONNAIRE_ATTACHMENT';
const UPLOAD_QUESTIONNAIRE_ATTACHMENT = 'UPLOAD_QUESTIONNAIRE_ATTACHMENT';
const UPLOAD_ALL_QUESTIONNAIRE_ATTACHMENT =
  'UPLOAD_ALL_QUESTIONNAIRE_ATTACHMENT';
const DELETE_QUESTIONNAIRE_ATTACHMENT = 'DELETE_QUESTIONNAIRE_ATTACHMENT';
const DELETE_ALL_QUESTIONNAIRE_ATTACHMENT =
  'DELETE_ALL_QUESTIONNAIRE_ATTACHMENT';
const VIEW_SCORES= 'VIEW_SCORES';  
const  VIEW_REQUEST_APPROVAL = 'VIEW_REQUEST_APPROVAL';

export default {
  CREATE_THIRD_PARTY_REQUESTS,
  MODIFY_OWNED_THIRD_PARTY_REQUESTS,
  MODIFY_ALL_THIRD_PARTY_REQUESTS,
  MODIFY_ALL_IN_FLIGHT_THIRD_PARTY_REQUESTS,
  MODIFY_ALL_REQUESTS_STATUSES,
  VIEW_THIRD_PARTY_REQUESTS,
  VIEW_OWNED_THIRD_PARTY_REQUESTS,
  VIEW_ALL_THIRD_PARTY_REQUESTS,
  VIEW_DEPT_THIRD_PARTY_REQUESTS,
  RENEW_ALL_THIRD_PARTY_REQUESTS,
  RENEW_OWNED_THIRD_PARTY_REQUESTS,
  EXPORT_REQUESTS,
  CREATE_PRESCREENING_QUESTIONS,
  MODIFY_PRESCREENING_QUESTIONS,
  CREATE_QUESTIONNAIRE_QUESTIONS,
  MODIFY_QUESTIONNAIRE_QUESTIONS,
  ADMIN_TOOLS,
  VIEW_ALL_USERS,
  VIEW_THIRD_PARTY_USER,
  VIEW_THIRD_PARTY_USER_FOR_THIRD_PARTY,
  CREATE_ALL_USERS,
  CREATE_THIRD_PARTY_USER_FOR_THIRD_PARTY,
  MODIFY_USERS,
  VIEW_THIRD_PARTY,
  CREATE_THIRD_PARTY,
  MODIFY_THIRD_PARTY,
  CREATE_THIRD_PARTY_USER,
  MODIFY_QUESTIONNAIRE,
  MODIFY_ANY_QUESTIONNAIRE,
  AUDIT_LOG,
  VIEW_QUESTIONNAIRE_ATTACHMENTS,
  CREATE_DISPLAY_CATEGORIES,
  MODIFY_DISPLAY_CATEGORIES,
  VIEW_DISPLAY_CATEGORIES,
  CREATE_QUESTION_TYPES,
  MODIFY_QUESTION_TYPES,
  VIEW_QUESTION_TYPES,
  CREATE_DEPARTMENTS,
  MODIFY_DEPARTMENTS,
  VIEW_DEPARTMENTS,
  VIEW_REQUEST_ATTACHMENT,
  VIEW_ALL_REQUEST_ATTACHMENT,
  UPLOAD_REQUEST_ATTACHMENT,
  UPLOAD_ALL_REQUEST_ATTACHMENT,
  DELETE_REQUEST_ATTACHMENT,
  DELETE_ALL_REQUEST_ATTACHMENT,
  VIEW_QUESTIONNAIRE_ATTACHMENT,
  VIEW_ALL_QUESTIONNAIRE_ATTACHMENT,
  VIEW_OWNED_QUESTIONNAIRE_ATTACHMENT,
  UPLOAD_QUESTIONNAIRE_ATTACHMENT,
  UPLOAD_ALL_QUESTIONNAIRE_ATTACHMENT,
  DELETE_QUESTIONNAIRE_ATTACHMENT,
  DELETE_ALL_QUESTIONNAIRE_ATTACHMENT,
  VIEW_SCORES,
  VIEW_REQUEST_APPROVAL
};
